export default {
  SET_STATE: "profile/SET_STATE",
  AUTH_USER: "profile/AUTH_USER",
  DEAUTH_USER: "profile/DEAUTH_USER",
  CHECK_IF_USER_LOGGEDIN: "profile/CHECK_IF_USER_LOGGEDIN",
  GET_CURRENT_USER: "profile/GET_CURRENT_USER",
  GET_USER_MUSICS: "profile/GET_USER_MUSICS",
  UPDATE_USER_STATUS: "profile/UPDATE_USER_STATUS",
  GET_ALL_ACHIEVEMENTS: "profile/GET_ALL_ACHIEVEMENTS",
  REG_USER: "profile/REG_USER",
};
